import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";
import { Range } from "views/components/date-range";

export enum InterviewPortalExportHistoryStatus {
    Processing = 0,
    Success = 1,
    PartialSuccess = 2,
    Failed = 3,
    Skip = 4
}

export enum InterviewPortalAimStatus {
    Pending = 0,
    ReadyToSend = 1,
    Success = 2,
    Error = 3
}

export enum ExportDataType {
    Application = 0,
    User = 1
}

export type AtsInterviewPortalExportHistoryFilter = {
    id?: string;
    organization?: string;
    interviewPortal?: string;
    status?: InterviewPortalExportHistoryStatus;
    range?: Range;
};

export type Phase = {
    id: string;
    name: string;
};

export class Season {
    Id: string;
    DefaultPhaseLabel: string;
    EvaluationPhases: Phase[] = [];
}

export class AtsInterviewPortalExportHistorySearchResult extends SearchResult<AtsInterviewPortalExportHistory> {}

export class AtsInterviewPortalExportHistoryMetaData {
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
}

export class AtsInterviewPortalExportHistory {
    Id: string;
    OrganizationId: string;
    OrganizationName: string;
    SeasonId: string;
    PhaseId: string;
    PreviousHistoryId: string;
    InterviewPortalId: string;
    ApplicationIds: string[];
    ApplicationCount: number;
    GetApplicationCsvErrorsCount: number;
    GetApplicationFullPdfErrorsCount: number;
    GetApplicationLimitedPdfErrorsCount: number;
    SaveFileErrorsCount: number;
    MissingApplicationsCount: number;
    GetApplicationCsvErrorsApplicationIds: string[];
    GetApplicationFullPdfErrorsApplicationIds: string[];
    GetApplicationLimitedPdfErrorsApplicationIds: string[];
    SaveFileErrorsApplicationIds: string[];
    MissingApplicationIds: string[];
    AbandonedApplicationIds: string[];
    CancelledApplicationIds: string[];
    NotEnrolledApplicationIds: string[];
    UsersIds: string[];
    UserCount: number;
    ExportDataType: ExportDataType;
    StatusMessage: string;
    Status: InterviewPortalExportHistoryStatus;
    Duration: number;
    @fromClass MetaData: AtsInterviewPortalExportHistoryMetaData;
}
